module.exports = __webpack_public_path__ + "img/discount.143e9f67.svg";